import { render } from "./TemplateCouponDetail.vue?vue&type=template&id=32cf94aa&scoped=true"
import script from "./TemplateCouponDetail.vue?vue&type=script&lang=js"
export * from "./TemplateCouponDetail.vue?vue&type=script&lang=js"

import "./TemplateCouponDetail.vue?vue&type=style&index=0&id=32cf94aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-32cf94aa"

export default script